export enum Gender {
  Male = "M",
  Female = "F",
  Unspecified = "N",
}

export enum PersonType {
  Individual = "F",
  LegalEntity = "J",
}

export enum DocumentType {
  RG = "RG",
  CPF = "CPF",
  CNPJ = "CNPJ",
  UNDEFINED = "UNDEFINED",
}
